import React from "react";

import BarChart from "components/pages/dashboard/chart/BarChart";
import usePatientsChart from "./usePatientsChart";

const PatientsChart = ({ data }) => {
  const { options, chartData } = usePatientsChart(data);

  return (
    <BarChart
      options={options}
      data={chartData}
      height={300}
      style={{ cursor: "pointer", height: "100%" }}
    />
  );
};

export default PatientsChart;
